import CheckCircle from "@endya-conformite/ui-kit/src/assets/icons/check-circle-fill.svg?react";
import InfoCircle from "@endya-conformite/ui-kit/src/assets/icons/question-circle-fill.svg?react";
import XCircle from "@endya-conformite/ui-kit/src/assets/icons/x-circle-fill.svg?react";
import { FunctionComponent, ReactElement } from "react";
import { Tag, TagVariant } from "./Tag";
import styles from "./Tag.module.scss";

const variantToIcon: Record<TagVariant, FunctionComponent> = {
  error: XCircle,
  success: CheckCircle,
  info: InfoCircle,
  warning: CheckCircle,
};
type TagProps = {
  children: string | ReactElement;
  variant?: TagVariant;
  className?: string;
  overrideIcon?: FunctionComponent;
};
export function TagWithIcon({
  children,
  variant = "success",
  className,
  overrideIcon,
}: TagProps) {
  const Icon = overrideIcon ?? variantToIcon[variant];
  return (
    <Tag variant={variant} className={className}>
      <div className={styles.tagContent}>
        <Icon />
        {children}
      </div>
    </Tag>
  );
}
